import { useEffect, useRef, type FC } from 'react';

import { TextLogo } from '@livechat/design-system-icons';
import { Icon, NavigationTopBarAlert } from '@livechat/design-system-react-components';

import { openInCard } from 'helpers/routing';

import { LEGACY_MIGRATION_COPY, getLegacyMigrationTopbarMessage, LegacyMigrationEvent } from './constants';
import { getLegacyMigrationLandingUrl, trackLegacyMigrationEvent } from './helpers';
import { useMigrationDaysLeft } from './use-migration-days-left';

import { migrationAlert, migrationAlertCta, migrationAlertMessage } from './styles';

interface Props {
  isVisible: boolean;
}

export const LegacyMigrationBar: FC<Props> = ({ isVisible }) => {
  const wasVisible = useRef(false);

  useEffect(() => {
    if (isVisible && !wasVisible.current) {
      trackLegacyMigrationEvent(LegacyMigrationEvent.TopbarDisplayed);
    }

    wasVisible.current = isVisible;
  }, [isVisible]);

  const handlePrimaryAction = (): void => {
    trackLegacyMigrationEvent(LegacyMigrationEvent.TopbarCtaClicked);
    openInCard(getLegacyMigrationLandingUrl());
  };

  const daysLeft = useMigrationDaysLeft();

  return (
    <NavigationTopBarAlert
      kind="info"
      isVisible={isVisible}
      className={migrationAlert}
      primaryCta={{
        label: LEGACY_MIGRATION_COPY.primaryAction,
        onClick: handlePrimaryAction,
        size: 'compact',
        kind: 'secondary',
        className: migrationAlertCta,
      }}
    >
      <span className={migrationAlertMessage}>
        <Icon source={TextLogo} size="medium" />
        {getLegacyMigrationTopbarMessage(daysLeft)}
      </span>
    </NavigationTopBarAlert>
  );
};
